import type { Locale } from "../locales";
import { en, type MessageKey, type Messages } from "./en";
import { es } from "./es";
import { fr } from "./fr";
import { de } from "./de";
import { it } from "./it";
import { ja } from "./ja";
import { vi } from "./vi";

export type { MessageKey, Messages };
export const MESSAGES: Record<Locale, Messages> = { en, es, fr, de, it, ja, vi };

export function translate(locale: Locale, key: MessageKey): string {
  return MESSAGES[locale][key] ?? en[key];
}
